import React, { useState } from "react";
import { Button, Row, Col } from "reactstrap";
import { ClipLoader } from "react-spinners";

import { useToast } from "../../hooks/toast";

function FileUpload({
  api,
  url,
  params,
  paramsFormData,
  accept,
  filekey,
  onSuccess,
}) {
  const [selectedFile, setSelectedFile] = useState();
  const [isSelected, setIsSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const parseUploadError = (error) => {
    const status = error?.response?.status;
    const payload = error?.response?.data || {};
    const responseErrors = Array.isArray(payload?.errors)
      ? payload.errors.filter(Boolean)
      : [];
    const responseError = typeof payload?.error === "string" ? payload.error : "";

    if (status === 409) {
      return {
        title: "Dados duplicados",
        description: responseError || "Foram encontrados dados duplicados.",
        details: responseErrors,
      };
    }

    if (responseErrors.length > 0 || responseError) {
      return {
        title: responseError || "Erro ao enviar!",
        description: responseError || "Falha ao importar arquivo.",
        details: responseErrors,
      };
    }

    const isLikelyInvalidFile = status === 400;
    const fallbackMessage = isLikelyInvalidFile
      ? "Arquivo invalido, verifique o arquivo!!"
      : "Nao foi possivel enviar o arquivo. Tente novamente.";

    return {
      title: "Erro ao enviar!",
      description: fallbackMessage,
      details: [],
    };
  };

  const handleSubmission = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append(filekey, selectedFile);

      if (paramsFormData) {
        paramsFormData.forEach((param) => {
          if (
            !param ||
            !param.name ||
            param.value === undefined ||
            param.value === null ||
            param.value === ""
          ) {
            return;
          }
          formData.append(param.name, param.value);
        });
      }

      const config = {
        headers: { "content-type": "multipart/form-data" },
        params: params,
      };
      const result = await api.post(url, formData, config);
      if (result.status >= 200 && result.status < 300) {
        const message = {
          place: "tr",
          type: "success",
          title: "Sucesso",
          description: "Enviado com sucesso!",
          icon: "tim-icons icon-check-2",
        };
        setSelectedFile();
        setIsSelected(false);
        if (onSuccess) {
          onSuccess(result);
        }
        addToast(message);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setSelectedFile();
      setIsSelected(false);
      const parsedError = parseUploadError(error);
      const hasDetails = parsedError.details.length > 0;
      const compRender = (
        <div style={{ textAlign: "left" }}>
          <p style={{ marginBottom: hasDetails ? 6 : 0 }}>
            {parsedError.description}
          </p>
          {hasDetails ? (
            <ul style={{ marginBottom: 0, paddingLeft: 18 }}>
              {parsedError.details.map((item, index) => (
                <li key={`${index}-${item}`}>{item}</li>
              ))}
            </ul>
          ) : null}
        </div>
      );

      const message = {
        place: "tr",
        type: "danger",
        title: parsedError.title,
        description: compRender,
        icon: "tim-icons icon-alert-circle-exc",
      };
      addToast(message);
    }
  };

  return (
    <div>
      <Row>
        <Col className="ml-auto mr-auto">
          <div>
            {Boolean(selectedFile) ? (
              <div>Arquivo selecionado: {selectedFile.name}</div>
            ) : (
              <label>
                Clique aqui para selecionar o arquivo ...
                <input
                  type="file"
                  name="file"
                  onChange={changeHandler}
                  accept={accept}
                  style={{ display: "none" }}
                />
              </label>
            )}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="ml-auto mr-auto mt-3">
          <Button
            disabled={!isSelected || loading}
            className="btn btn-round btn-success"
            onClick={() => handleSubmission()}
          >
            {loading ? "Enviando..." : "Enviar"}
          </Button>
        </Col>
      </Row>
      {loading ? (
        <div style={{ textAlign: "center" }}>
          <ClipLoader
            sizeUnit="px"
            size={90}
            color="#1d8cf8"
            loading={loading}
          />
          <br />
          <br />
          <h1 className="text-info" style={{ textAlign: "center" }}>
            Enviando ...
          </h1>
        </div>
      ) : null}
    </div>
  );
}

export default FileUpload;
